/* scroll-effect.js — pinned hero + header background fade-in (snap handoff) */
document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const hero   = document.querySelector('#heroPin');
  const logo   = document.querySelector('#heroLogo');
  const header = document.querySelector('#siteHeader') ||
                 document.querySelector('#header-component') ||
                 document.querySelector('.site-header');
  if (!hero || !logo || !header) return;

  // Ensure hero has correct pinning baseline (defensive)
  Object.assign(hero.style, { height: '100vh', margin: '0', overflow: 'hidden', zIndex: 1 });

  const headerH  = header.offsetHeight;
  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  // Header visible from start; fade background via CSS var
  gsap.set(header, { y: 0, autoAlpha: 1 });
  header.style.setProperty('--bgA', 0);

  // Amount to lift the big VEZZO mark
  // Base lift plus compensation for .hero-logo { margin-top: 39vh }
  const baseLiftY = -(window.innerHeight / 2 + headerH);
  const marginCompY = -window.innerHeight * 0.39; // 39vh
  const liftY = baseLiftY + marginCompY;

  // One pinned scrub timeline (shorter distance for a quicker handoff)
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: '+=70%',         // was 'bottom top' — shorter pin for faster transition
      pin: true,
      scrub: true,
      anticipatePin: 1,
      onLeave() { // when hero releases (down)
        header.style.setProperty('--bgA', '1');
        header.classList.add('header--solid');
        header.classList.remove('header--transparent');
      },
      onEnterBack() { // back into hero (up)
        header.style.setProperty('--bgA', '0');
        header.classList.add('header--transparent');
        header.classList.remove('header--solid');
      }
    }
  });

  // Logo motion: travel all the way to the top edge and scale to match navbar mark
  // No opacity fade — the handoff visually "snaps" when the header turns solid.
  tl.to(logo, { y: liftY, scale: 0.26, ease: 'power2.inOut' }, 0.10);

  // Header background opacity ramps near the end (snappier)
  const fadeStart = isMobile ? 0.80 : 0.78;
  tl.to(header, {
    ease: 'none',
    onUpdate() {
      const p = tl.progress();
      const t = Math.min(1, Math.max(0, (p - fadeStart) / (1 - fadeStart)));
      header.style.setProperty('--bgA', t.toFixed(3));
    }
  }, 0);

  // Subtle background scale
  tl.to('.hero-bg-img', { scale: 1.08, ease: 'none' }, 0);
});
